import { request } from '@/shared/api/request'

export const sendTradeUnionSignedXml = (isEmployee, signedXml) => {
	return request({ url: `colcontract/ecd/tradeUnion/sign?isEmployee=${isEmployee}`, method: 'POST', data: signedXml })
}
